import React, { SFC } from 'react';
import { ISubscription } from 'interfaces/IProductData';
import { SubscriptionWithTax } from './SubscriptionWithTax/index';
import { SubscriptionWithTrial } from './SubscriptionWithTrial';
import { SubscriptionWithoutTaxTrial } from './SubscriptionWithoutTaxTrial/index';

interface IPriceProps {
  subscription: ISubscription;
}

// tslint:disable-next-line:variable-name
export const Subscription: SFC<IPriceProps> = (props) => {

  const { subscription } = props;

  return (
    <div>
      {subscription.hasTax
        ? <SubscriptionWithTax subscription={subscription} />
        : null
      }

      {subscription.hasTrial
        ? <SubscriptionWithTrial subscription={subscription} />
        : null
      }

      {!subscription.hasTax && !subscription.hasTrial
        ? <SubscriptionWithoutTaxTrial subscription={subscription} />
        : null
      }
    </div>
  );
};


// WEBPACK FOOTER //
// ./src/components/Cart/Price/Subscription/index.tsx